import requests from "@/utils/request";
import store from "@/store";

let request = requests.request;
let lang = store.state.isLang != "zh-CN" ? "en_en" : "zh_cn";

// 首页
export const toIndex = (data) => request.post("index", { lang, ...data });

// 产品详情
export const toGoodInfo = (data) =>
  request.post("good_info", { lang, ...data });

// 热门类型
export const toHotType = (data) => request.post("hotType", { lang, ...data });

// 关于我们
export const toAbout = (data) => request.post("about", { lang, ...data });

// 插入留言
export const toMessage = (data) => request.post("message", { lang, ...data });

// 所有类型导航栏
export const toType = (data) => request.post("allType", { lang, ...data });

// 查看图片详情
export const toImgInfo = (data) => request.post("img_info", { lang, ...data });

// 全文搜索
export const toSearch = (data) => request.post("search", { lang, ...data });

// 帮助中心
export const toHelp = (data) => request.post("help_list", { lang, ...data });

// 帮助中心-查看详情
export const toHelpInfo = (data) =>
  request.post("help_info", { lang, ...data });

// 记录访客访问
export const getVisitorRecord = (data) =>
  request.post("/visitorRecord", { lang, ...data });
